import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  totalRecommendationSavings: {
    defaultMessage: '<bold>{savingsAmount} in Savings</bold> on these shipments',
    description: 'Total potential savings for a list of shipments',
    id: 'sus/hU',
  },
  applyToAll: {
    defaultMessage: 'Apply to All',
    description: 'Button to apply all recommendations',
    id: '7s2rt8',
  },
});
